import { useState } from 'react';
import "./QuestionSelect.css";
import { Question } from 'effno-core';
import { FormQuestionTag } from '../form-question/FormQuestionTag';

type QuestionSelectProps = {
    selected?: string;
    questions: Question[];
    onChange: (questionId: string) => void;
}

export const QuestionSelect = ({ selected, questions, onChange, ...rest }: QuestionSelectProps) => {

	const [isOpen, setIsOpen] = useState(false);

    let selectedQuestion : Question | undefined = undefined;

    if (selected) {
        selectedQuestion = questions.find((question) => question.id === selected);
    }

    console.log("[QuestionSelect] selected: ", selected);
    console.log("[QuestionSelect] questions: ", questions);


    return (
		<div className="question-select-container">
            <div 
                className="question-select"
                onClick={() => setIsOpen(!isOpen)}
                style={isOpen ? {zIndex: 101} :{}}
            >
                {selected && selectedQuestion &&
                    <div className="question-select-selected">
                        <FormQuestionTag type={selectedQuestion.type} /> 
                        <div className="question-select-title">
                            {selectedQuestion.title}
                        </div>
                    </div>
                }

                {isOpen &&
                    <div className="question-select-options">
                        {questions.map((question: Question) => {
                            return (				
                                <div 
                                    key={question.id}
                                    className="question-select-option"
                                    onClick={() => {
                                        onChange(question.id);
                                        setIsOpen(false);
                                    }}
                                >
									<FormQuestionTag type={question.type} /> 
                                    <div className="question-select-title">
                                        {question.title}
                                    </div>
                                </div>
                            )
                        }
                        )}
                    </div>
                }

            </div>
        </div>
    )
}
